// mutations
const ADMIN_SCHOOLS_ALL = (state, adminSchools) => {
  if (adminSchools.code === 1) {
    state.adminSchools = adminSchools.data
    state.status = 'success'
  } else {
    alert(adminSchools.message)
    state.status = 'error'
  }
}

const ADMIN_SCHOOLS_FORM = (state, adminSchools) => {
  if (adminSchools.code === 1) {
    state.adminSchools = adminSchools.data
    state.status = 'success'
  } else {
    alert(adminSchools.message)
    state.status = 'error'
  }
}

const ADMIN_SCHOOLS_SHOW = (state, adminSchools) => {
  if (adminSchools.code === 1) {
    state.adminSchools = adminSchools.data
    state.status = 'success'
  } else {
    alert(adminSchools.message)
    state.status = 'error'
  }
}

const ADMIN_SCHOOLS_CREATE = (state, adminSchools) => {
  if (adminSchools.code === 1) {
    state.adminSchools = adminSchools.data
    state.status = 'success'
    alert(adminSchools.message)
  } else {
    alert(adminSchools.message)
    state.status = 'error'
  }
}

const ADMIN_SCHOOLS_UPDATE = (state, adminSchools) => {
  if (adminSchools.code === 1) {
    state.adminSchools = adminSchools.data
    state.status = 'success'
    alert(adminSchools.message)
  } else {
    alert(adminSchools.message)
    state.status = 'error'
  }
}

const ADMIN_SCHOOLS_DELETE = (state, adminSchools) => {
  if (adminSchools.code === 1) {
    state.adminSchools = adminSchools.data
    state.status = 'success'
    alert(adminSchools.message)
  } else {
    alert(adminSchools.message)
    state.status = 'error'
  }
}

export default {
  ADMIN_SCHOOLS_ALL,
  ADMIN_SCHOOLS_FORM,
  ADMIN_SCHOOLS_SHOW,
  ADMIN_SCHOOLS_CREATE,
  ADMIN_SCHOOLS_UPDATE,
  ADMIN_SCHOOLS_DELETE
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/schools/mutations.js